import { useState } from "react";
import { Maximize2 } from "lucide-react";
import MediaModal from "../Common/MediaModal";
import CustomTooltip from "../Tooltip/CustomTooltip";
import StorageImage from "./StorageImage";

const MdImage = ({ src, alt }) => {
  const [showModal, setShowModal] = useState(false);

  const openImageModal = () => setShowModal(true);
  const closeImageModal = () => setShowModal(false);

  // Don't render anything if src is empty, null, or undefined
  if (!src || src.trim() === "") {
    return null;
  }

  if (alt === "ASSET") {
    return <StorageImage src={src} alt={alt} />;
  }

  // Handle private GCS URLs through backend proxy
  if (src?.startsWith("gs://")) {
    const encodedPath = encodeURIComponent(src);
    const proxyUrl = `/api/image/${encodedPath}`;
    return (
      <>
        <div className="relative group inline-block">
          <img
            src={proxyUrl}
            alt={alt || ""}
            className="max-w-full h-auto rounded-md my-2 cursor-pointer hover:opacity-90 transition-opacity"
            onClick={openImageModal}
          />
          <div className="absolute top-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity">
            <CustomTooltip content="Fullscreen" side="top" align="center">
              <button
                onClick={openImageModal}
                className="flex items-center p-2 bg-fill-white dark:bg-fill-editor-surface border-[0.5px] dark:border-edge-editor-border border-edge-border text-ink-ink dark:text-ink-white rounded-lg hover:bg-fill-gray-100 dark:hover:bg-fill-editor-hover transition-colors"
                aria-label="View fullscreen"
              >
                <Maximize2 className="w-3.5 h-3.5 hover:scale-110 transition-transform" />
              </button>
            </CustomTooltip>
          </div>
        </div>

        {showModal && (
          <MediaModal src={proxyUrl} alt={alt} onClose={closeImageModal} />
        )}
      </>
    );
  }

  return (
    <>
      <div className="relative group inline-block">
        <img
          src={src}
          alt={alt || ""}
          className="max-w-full h-auto rounded-md my-2 cursor-pointer hover:opacity-90 transition-opacity"
          onClick={openImageModal}
        />
        <div className="absolute top-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity">
          <CustomTooltip content="Fullscreen" side="top" align="center">
            <button
              onClick={openImageModal}
              className="flex items-center p-2 bg-fill-white dark:bg-fill-editor-surface border-[0.5px] dark:border-edge-editor-border border-edge-border text-ink-ink dark:text-ink-white rounded-lg hover:bg-fill-gray-100 dark:hover:bg-fill-editor-hover transition-colors"
              aria-label="View fullscreen"
            >
              <Maximize2 className="w-3.5 h-3.5 hover:scale-110 transition-transform" />
            </button>
          </CustomTooltip>
        </div>
      </div>

      {showModal && (
        <MediaModal src={src} alt={alt} onClose={closeImageModal} />
      )}
    </>
  );
};

export default MdImage;
